export const tabsStyleHookMapping = {
  tabActivationDirection: dir => ({
    'data-activation-direction': dir
  })
};